import type { CommerceHttpAdapter } from '../../client/CommerceHttpAdapter.js'
import type {
  Cart,
  PaymentRequestData,
  PaymentPreparationData,
  PaymentPreparationResult,
  PaymentRedirectStartResult,
  UsablePaymentMethodWebDescriptor,
} from '../../types/index.js'

export class PaymentsModule {
  constructor(private readonly http: CommerceHttpAdapter) {}

  getChoicesPrivate(): Promise<UsablePaymentMethodWebDescriptor[]> {
    return this.http.get<UsablePaymentMethodWebDescriptor[]>('/commerce/api/process/payments/choices/private')
  }

  preparePaymentPrivate(request: PaymentPreparationData): Promise<PaymentPreparationResult> {
    return this.http.post<PaymentPreparationResult>('/commerce/api/process/payments/prepare/private', request)
  }

  registerPaymentPrivate(request: PaymentRequestData): Promise<Cart> {
    return this.http.post<Cart>('/commerce/api/process/payments/register/private', request)
  }

  async startRedirectPayment(request: PaymentPreparationData): Promise<PaymentRedirectStartResult> {
    const preparationResult = await this.preparePaymentPrivate(request)
    const preparation = preparationResult.preparation
    const redirectUrl = preparation?.data?.redirectUrl ?? preparation?.data?.paymentUrl

    if (!redirectUrl || redirectUrl.trim().length === 0) {
      throw new Error('La preparation du paiement ne contient pas d\'URL de redirection.')
    }

    const pspReference = preparation?.data?.pspReference?.trim() || undefined
    const cart = await this.registerPaymentPrivate({
      paymentMethodGuid: request.paymentMethodGuid,
      amount: request.amount,
      autoValidated: request.autoValidated,
      referenceNumber: pspReference ?? request.referenceNumber,
    })

    return {
      preparationResult,
      cart,
      redirectUrl,
      pspReference,
    }
  }
}